import Grid from '@material-ui/core/Grid/Grid';
import { getCdnImage } from 'functions';
import React from 'react';
import { cartService } from 'services/CartService';
import { useMappedObservable } from 'shared/hooks/useMappedObservable';

import ShowDetails from './ShowDetails';

export interface IProps {
  shouldRenderModal: boolean;
}

export const HeaderTitle: React.FC<IProps> = React.memo(props => {
  const [data] = useMappedObservable(
    () => {
      return cartService.getCart().combineLatest(cartService.getConfig());
    },
    ([cart, config]) => {
      return {
        logo: config.logo,
        title: cart.content.title
      };
    },
    []
  );

  if (!data) {
    return null;
  }

  const image = getCdnImage(data.logo);
  const { shouldRenderModal } = props;

  return (
    <Grid container={shouldRenderModal} className={shouldRenderModal ? 'no-open-modal' : 'open-modal-description'}>
      <Grid item xs={window.innerWidth < 500 ? 3 : 2}>
        {image && <img className="chk-img" src={image} id="logo-content" />}
      </Grid>
      <Grid item zeroMinWidth xs={9}>
        <h1 className="product-name theme-label">{data.title}</h1>
        {shouldRenderModal && <ShowDetails />}
      </Grid>
    </Grid>
  );
});

export default HeaderTitle;
